import cx from 'classnames';
import { TeamLogo } from '../TeamLogo';
import { SGPBadge } from './SGPBadge';
import { useAppProps } from '../../contexts';
import { EventCard as EventCardType, SGPBadgeDark } from '../../contracts';

import './index.scss';

export const EventCard = ({ teams, startDate, period, timer, isLive, isSgp, href }: EventCardType) => {
    const { dictionary } = useAppProps();

    return (
        <a href={href} className="sl-event-card">
            <div className="sl-event-card__header">
                <div className="sl-event-card__info">
                    {isLive || period ? (
                        <div className="sl-event-card__status">
                            {period && (
                                <span className="sl-event-card__period" data-testid="sl-event-card-period">
                                    {period}
                                </span>
                            )}
                            {timer && (
                                <span className="sl-event-card__timer" data-testid="sl-event-card-timer">
                                    {timer}
                                </span>
                            )}
                        </div>
                    ) : (
                        <span className="sl-event-card__date" data-testid="sl-event-card-date">
                            {startDate}
                        </span>
                    )}
                </div>
                {isSgp && (
                    <span className="sl-event-card__sgp-wrapper" data-testid="sgp-wrapper">
                        <SGPBadge className="sl__sgp-badge-icon" {...SGPBadgeDark} />
                    </span>
                )}
            </div>
            <div className="sl-event-card__teams">
                {teams.map(({ logoUrl, name, score, isServing }, index) => (
                    <div
                        key={index}
                        className={cx('sl-event-card__team', { 'sl-event-card__team--is-serving': isServing })}
                        data-testid="sl-event-card-team"
                    >
                        <div className="sl-event-card__team-info" data-testid="sl-event-card-team-info">
                            {logoUrl && (
                                <TeamLogo
                                    className="sl-event-card__team-logo"
                                    data-testid="sl-event-card-team-logo"
                                    alt={`${name} ${dictionary.logo}`}
                                    src={logoUrl}
                                    onErrorBehaviour="hide"
                                />
                            )}
                            <span className="sl-event-card__team-name" data-testid="sl-event-card-team-name">
                                {name}
                            </span>
                        </div>
                        <div
                            className={cx('sl-event-card__team-score', {
                                'sl-event-card__team-score--highlighted': isLive
                            })}
                        >
                            {score}
                        </div>
                    </div>
                ))}
            </div>
        </a>
    );
};
